import { VStack, HStack, Box } from "@chakra-ui/react";
import { ClickEventType, colors, customEvent, getCdnImageSrc } from "goi_common";

import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";

import Slider from "react-slick";
import styled from "@emotion/styled";

import Image from "next/image";

export function ImageSlider({
  time = 2800,
  slideItems,
  eventPath = "product_main",
  aspectRatio = "1.25/1",
}: {
  time?: number;
  slideItems: {
    href: string;
    imageSrc: string;
    triggerAndTarget: ClickEventType["trigger_and_target"];
  }[];
  eventPath: ClickEventType["path"];
  aspectRatio?: string;
}) {
  const router = useRouter();
  const [
    ,
    // slider
    setSlider,
  ] = useState<Slider | null>();
  // const totalSlides = slideItems?.length;
  const [currentIndex, setCurrentIndex] = useState(0);

  // setTimeout을 저장할 ref
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // 컴포넌트 언마운트 시 setTimeout 정리
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleSlideClick = (
    href: string,
    triggerAndTarget: ClickEventType["trigger_and_target"],
  ) => {
    customEvent({
      newGtm: {
        path: eventPath,
        trigger_and_target: triggerAndTarget,
      },
    });
    if (href.startsWith("http")) {
      window.location.href = href;
    } else {
      router.push(href);
    }
  };

  return (
    <>
      <VStack gap={0} alignItems="center" width="100%">
        <Slide
          $aspectRatio={aspectRatio}
          css={{
            width: "100%",
            aspectRatio,
          }}
          initialSlide={0}
          arrows={false}
          infinite={true}
          variableWidth={true}
          ref={(s) => setSlider(s)}
          autoplay={true}
          autoplaySpeed={time}
          beforeChange={(current, next) => {
            setCurrentIndex(next);
          }}
        >
          {slideItems.map(({ href, imageSrc, triggerAndTarget }, index) => (
            <Box
              key={href + "reviewslick"}
              onClick={() => handleSlideClick(href, triggerAndTarget)}
              cursor="pointer"
              css={{
                width: "100%",
                aspectRatio,
                position: "relative",
              }}
            >
              <Image
                src={getCdnImageSrc(imageSrc)}
                alt={triggerAndTarget}
                fill
                css={{
                  borderRadius: "12px",
                }}
              />
            </Box>
          ))}
        </Slide>

        <HStack
          spacing={0}
          css={{
            width: "100%",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          {slideItems &&
            slideItems.length > 1 &&
            slideItems.map((_, index) => (
              <Box
                key={index}
                width="8px"
                height="8px"
                borderRadius="50%"
                backgroundColor={currentIndex === index ? colors.gray900 : colors.gray200}
                transition="background-color 0.3s"
              />
            ))}
        </HStack>
      </VStack>
    </>
  );
}

const Slide = styled(Slider)<{ $aspectRatio?: string }>`
  .slick-track {
    display: flex !important;
  }

  .slick-list {
    padding: 0px !important;
  }

  .slick-slide {
    width: 100%;
    aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "1.25/1"};
    line-height: 0;
  }
`;
